import { useAtomValue } from 'jotai';
import * as React from 'react';
import { Image } from 'react-native';
import {
    BodyMediumEmphasized,
    EditIcon,
    hitSlop,
    Icon,
    View,
    XStack,
    YStack,
} from 'smoothie';

import ArrowShort from '../../../../../assets/images/banking/paycheck-routing/arrow-short.png';
import LineShort from '../../../../../assets/images/banking/paycheck-routing/line-short.png';
import { currentlyEditingConfigAtom } from '../../../state/PaycheckRoutingAtoms';
import { bankAccountDisplayDetails } from '../../../state/SpacesAtoms';
import RuleSummary from '../common/RuleSummary';
import RemainingRulesEditor from './rule-editor/remaining/RemainingRulesEditor';

const RulesList = () => {
    const currentlyEditingConfig = useAtomValue(currentlyEditingConfigAtom);
    const bankAccountDetails = useAtomValue(bankAccountDisplayDetails);

    return (
        <XStack gap={8}>
            <YStack marginLeft={16}>
                {Array.from({
                    length: (currentlyEditingConfig?.rules?.remaining ?? [])
                        .length,
                }).map((_, i) => (
                    <View key={i}>
                        <Image
                            key={i}
                            source={ArrowShort}
                            style={{
                                height: 46,
                                resizeMode: 'stretch',
                            }}
                        />
                        {i <
                            (currentlyEditingConfig.rules?.remaining ?? [])
                                .length -
                                1 && (
                            <Image
                                source={LineShort}
                                style={{
                                    height: 26,
                                }}
                            />
                        )}
                    </View>
                ))}
            </YStack>
            <YStack marginTop={16} gap={20}>
                {(currentlyEditingConfig.rules?.remaining ?? []).map((rule) => {
                    const account =
                        rule.accountMetadata ??
                        bankAccountDetails.find(
                            (account) =>
                                account.bankAccountId === rule.accountId,
                        );
                    if (!account) return null;

                    return (
                        <RuleSummary
                            key={rule.id}
                            rule={rule}
                            account={account}
                        />
                    );
                })}
            </YStack>
        </XStack>
    );
};

interface RemainingRulesProps {
    isEditingRemainingRules: boolean;
    isEditingRule: boolean;
    setIsEditing: (isEditing: boolean) => void;
}

const RemainingRules = ({
    isEditingRemainingRules,
    isEditingRule,
    setIsEditing,
}: RemainingRulesProps) => {
    return (
        <YStack gap={8}>
            <XStack justifyContent="space-between" alignItems="center">
                <BodyMediumEmphasized>Remainder goes to</BodyMediumEmphasized>
                {!isEditingRemainingRules && !isEditingRule && (
                    <View
                        animation="button"
                        pressStyle={{ scale: 0.95 }}
                        onPress={() => {
                            setIsEditing(true);
                        }}
                        {...hitSlop(16)}
                    >
                        <Icon icon={EditIcon} color="$gray1000" />
                    </View>
                )}
            </XStack>
            {isEditingRemainingRules ? (
                <RemainingRulesEditor setIsEditing={setIsEditing} />
            ) : (
                <RulesList />
            )}
        </YStack>
    );
};

export default RemainingRules;
